import type { UserKind } from 'common/enums/user-kind.enum';
import type { Gender } from 'common/enums/gender.enum';
import type { StudyLevel } from 'common/enums/study-level.enum';
import type { Nationality } from 'common/enums/nationality.enum';
import type { ProfessionalSituation } from 'common/enums/professional-situation.enum';
import type { UnemployedLength } from 'common/enums/unemployed-length.enum';
import type { JobStatus } from 'common/enums/job-status.enum';
import type { EducationFunction } from 'common/enums/education-function.enum';
import type { TypeOfTeaching } from 'common/enums/type-of-teaching.enum';
import type { AddressInterface } from 'frontend/interfaces/address';
import BaseChangeset from 'common/changesets/base';

export type ProfileDTO = {
  id?: string;
  kind?: UserKind;
  newsAgreement?: boolean;
  applicant: {
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    companyNumber?: string;
    companyName?: string;
    institution?: string;
    cooperationAgreement?: boolean;
  };
  gender?: Gender | null;
  nationality?: Nationality | null;
  professionalSituation?: ProfessionalSituation | null;
  unemployedLength?: UnemployedLength | null;
  studyLevel?: StudyLevel | null;
  address?: AddressInterface;
  isBillingAddress?: boolean;
  billingAddress?: AddressInterface;
  isCommittee?: boolean;
  isTrainingVoucher?: boolean;
  function?: string;
  jobStatus?: JobStatus | null;
  educationFunction?: EducationFunction | null;
  faseNumber?: string;
  typeOfTeaching?: TypeOfTeaching | null;
};

export class ProfileChangeset extends BaseChangeset<ProfileDTO> {}
